import VGet from './v-get';
export default class VError extends VGet {
  compute([obj, path]) {
    return super.compute([obj, path, 'message']);
  }
}